import { render } from "./PackageItem.vue?vue&type=template&id=f8a9bb80&scoped=true&ts=true"
import script from "./PackageItem.vue?vue&type=script&lang=ts"
export * from "./PackageItem.vue?vue&type=script&lang=ts"

import "./PackageItem.vue?vue&type=style&index=0&id=f8a9bb80&scoped=true&lang=css"

import exportComponent from "/Users/lxb/kuaike/kunpeng-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8a9bb80"]])

export default __exports__